const crashReporter = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    console.error("Caught an exception!", err);
    //TODO Write our own exception capture
    throw err;
  }
};

export default crashReporter;
